module.exports = __webpack_public_path__ + "img/99.42078427.jpg";